"use client";

import { BSRExpand } from "./bsr/BSRExpand";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Expand as LegacyExpand } from "./legacy/Expand";

export const Expand = createBSRExperimentIcon(LegacyExpand, BSRExpand);
